'use strict';

/**
 * @ngdoc service
 * @name gestiondecriseApp.CrewUsersFunctionsService
 * @description
 * # CrewUsersFunctionsService
 * Service in the gestiondecriseApp.
 */
angular.module('gestiondecriseApp').service('CrewUsersFunctionsService', function ($q, RequestService) {
  var CrewUserFunction = Parse.Object.extend('CrewUserFunction');
  var CrewFunction = Parse.Object.extend('CrewFunction');

  this.getAll = function () {
    var deferred = $q.defer();

    RequestService.performCountQuery(
      new Parse.Query(CrewUserFunction),
      function (count) {
        var query = new Parse.Query(CrewUserFunction);
        query.limit(count);
        RequestService.performFindQuery(
          query,
          function (parseUFs) {
            deferred.resolve(_.map(parseUFs, _transformParseCrewUserFunctionToObject));
          },
          function (error) {
            deferred.reject(error);
          }
        );
      },
      deferred.reject
    );

    return deferred.promise;
  };

  this.getFunctionsForUser = function (user) {
    var deferred = $q.defer();
    var userFunctionQuery = new Parse.Query(CrewUserFunction);
    userFunctionQuery.equalTo('userId', user.userId);
    //userFunctionQuery.include('function');

    var functionQuery = new Parse.Query(CrewFunction);
    functionQuery.matchesKeyInQuery('code', 'code', userFunctionQuery);

    RequestService.performFindQuery(
      functionQuery,
      function (parseFunctions) {
        deferred.resolve(_.map(parseFunctions, _transformParseCrewFunctionToObject));
      },
      function (error) {
        deferred.reject(error);
      }
    );

    return deferred.promise;
  };

  var _transformParseCrewFunctionToObject = function (parseObject) {
    return {
      objectId: parseObject.id,
      code: parseObject.get('code'),
      label: parseObject.get('label'),
      isTechnique: parseObject.get('isTechnique'),
    };
  };

  var _transformParseCrewUserFunctionToObject = function (parseObject) {
    return {
      objectId: parseObject.id,
      code: parseObject.get('code'),
      userId: parseObject.get('userId'),
    };
  };
});
